<template>
	<div id="PageRentalTypes">
		<div class="wrapper-fluid bg-picture-darken small-nav">


			

			<div class="container content-faq">

				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block" >{{ $t('Gutscheincode') }}</h1>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row justify-content-center headinline">
							<div class="col-md-9">
								<p>Gutscheincode</p>
							</div>
						</div>
						<div class="row justify-content-center">
							<div class="col-xs-12 col-sm-6 col-lg-4">
								<CsInput
								autocomplete="voucher"

								:placeholder="$t('Gutscheincode')"
								:id="'voucher'"
								:name="'voucher'"
								v-model="voucher"
								></CsInput>
							</div>
					</div>
						</div>
					</div>
					<div class="row">
						<div class="col text-center col-cta-button">
							<button @click="checkVoucher" type="button" class="btn btn-primary btn-wp">
								{{ $t('Weiter') }}
							</button>
						</div>
					</div>
					</div>
				</div>
				
			</div>

		</div>
	</div>
</template>


<script>

import { mapGetters } from 'vuex';
export default {
	name: 'PageVoucher',
	computed: {
		...mapGetters('orm/reservation', {
	    	user_session: 'user_session'
	    }),
	},
	data() {
		return {
			voucher: "",
			isVoucher: true,
		};
	},
	mounted() {
		var self = this;

		this.$store.commit('orm/reservation/UNSET_VOUCHER');
	},
	methods: {
		checkVoucher(){
			var self = this;

			if (self.voucher === ""){
				this.nextPage();
				return;
			}
			

			this.$store.dispatch('orm/CHECK_VOUCHER', {
					code: self.voucher,
					type: 'MOBILITY'
				}).then(res => { 
					console.log(res.result);
					if(!res.result){

						self.$validator.errors.add({
						id: 'voucher',
						field: 'voucher',
						msg: 'kein gültiger Code',
						});
					}else{
						this.$store.commit('orm/reservation/SET_VOUCHER', self.voucher);
						this.nextPage();
					}
				}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });
		},

		nextPage(){

			if(!this.user_session) {
				this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
			} else {
					this.$router.push({
						name: 'PageSummary'});
			}

		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/Pages/PageVoucher.vue